// extracted by mini-css-extract-plugin
module.exports = {"returnsForm__button":"styles_returnsForm__button__T8O70","returnsForm__form":"styles_returnsForm__form__u9FRN"};